module.exports = __webpack_public_path__ + "img/bgc.b88ac725.png";